/**
 * Text-label tool — placement interaction helpers.
 *
 * Flow:
 *   1. User activates the "text" drawing tool.
 *   2. Chart click → `placeTextLabel(time, price, tabId, dispatch)`
 *      places an empty label, selects it, and deactivates the tool. The
 *      caller opens the inline editor on the returned id so the user can
 *      type immediately (TradingView-style).
 *   3. Double-click an existing label to re-open the inline editor.
 */
import { nanoid } from "nanoid";
import type { AppDispatch } from "@/state/store";
import {
  addTextLabel,
  setSelectedDrawing,
} from "@/state/slices/uiSlice";

export function placeTextLabel(
  time: number,
  price: number,
  tabId: string,
  dispatch: AppDispatch,
): string {
  const id = nanoid();
  dispatch(
    addTextLabel({
      tabId,
      label: { id, time, price, text: "" },
    }),
  );
  dispatch(setSelectedDrawing({ tabId, selected: { kind: "text", id } }));
  return id;
}
